import { Component, OnInit, Inject } from "@angular/core";
import { ActivatedRoute, Params } from "@angular/router";

import { Resource, ADPResourceService as ResourceService } from "digital-core";

@Component({
  selector: 'login',
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.css"]
})
export class LoginComponent implements OnInit {
  accessToken: string = "";
  refreshToken: string = "";
  constructor(
    private route: ActivatedRoute,
    private resourcesService: ResourceService,
  ) { }

  ngOnInit() {


    this.route.params.subscribe(params => {

      this._processParameters(params);

      this.route.data.subscribe(
        (data: { resources: { [id: string]: Resource } }) => {
          this.resourcesService.setGlobalResources(data.resources);
        }
      );
    }
    );

  }

  private _processParameters(params: Params) {
    if (params && params['accessToken'] && params['accessToken'] != "") {
      this.accessToken = decodeURIComponent(params['accessToken']);
    }
    if (params && params['refreshToken'] && params['refreshToken'] != "") {
      this.refreshToken = decodeURIComponent(params['refreshToken']);
    }
  }
}
